import cls from 'classnames';
import { FC, ComponentPropsWithoutRef } from 'react';

import useStyles from './styles';

export function IconRound({
  className,
  Icon,
  ...rest
}: ComponentPropsWithoutRef<'div'> & {
  Icon: FC<{ className: string }>;
}) {
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={cls('flex', 'align-center', 'justify-center', classes.root, className)}
    >
      <Icon className={classes.icon} />
    </div>
  );
}

export default IconRound;
